/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { Button, Theme } from '@mui/material';
import { withStyles } from '@mui/styles';
import * as React from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { Category, CategoryType } from '../common/Categories';
import { editUserRoleRoute, editUserRoute } from '../common/constants';
import { actionCreators as roleActionCreators } from '../store/Role';
import { actionCreators as userActionCreators } from '../store/User';

const styles = (theme: Theme) => ({
    link: {
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'none'
        }
    },
    editBtn: {
        backgroundColor: '#ffffff',
        marginRight: '5px'
    }
});

interface Props {
    selected: any;
    selectedCategory?: Category;
    saveSelectedUserRequest: (user: any) => void;
    saveSelectedRoleRequest: (role: any) => void;
    classes?: any;
}

const Edit: React.FC<Props> = ({ selected, selectedCategory, saveSelectedUserRequest, saveSelectedRoleRequest, classes }) => {
    const navigate = useNavigate();

    const handleClick = () => {
        if (!selectedCategory || selected == null || (Array.isArray(selected) && selected.length === 0)) {
            return;
        }

        if (selectedCategory.type === CategoryType.User) {
            saveSelectedUserRequest(selected);
            navigate(`${editUserRoute}/${selected.id}`);
        }

        if (selectedCategory.type === CategoryType.UserRole) {
            saveSelectedRoleRequest(selected);
            navigate(`${editUserRoleRoute}/${selected.id}`);
        }
    };

    const disabled = selected == null || (Array.isArray(selected) ? selected.length === 0 : !selected.id);

    return (
        <div>
            {(selectedCategory?.type === CategoryType.User || selectedCategory?.type === CategoryType.UserRole) && (
                <Button onClick={handleClick} variant="outlined" className={classes.editBtn} disabled={disabled}>
                    Edit
                </Button>
            )}
        </div>
    );
};

const mapDispatchToProps = (dispatch: any) => {
    return bindActionCreators({ 
        saveSelectedUserRequest: userActionCreators.saveSelectedUserRequest,
        saveSelectedRoleRequest: roleActionCreators.saveSelectedRoleRequest
    }, dispatch);
}

const ConnectedEdit = connect(
    null,
    mapDispatchToProps
)(withStyles(styles)(Edit));

export default ConnectedEdit as React.ComponentType<Omit<Props, 'saveSelectedUserRequest' | 'saveSelectedRoleRequest'>>;
